import { Stack } from 'expo-router';
import Head from 'expo-router/head';

import Home from '../screens/home';

export default function HomePage() {
  return (
    <>
      <Head>
        <title>Alexander Kalapsazov | React Native Developer</title>
        <meta
          name="description"
          content="React Native developer portfolio with experience in production mobile apps, architecture, testing, and animation."
        />
      </Head>
      <Stack.Screen options={{ headerShown: false }} />
      <Home />
    </>
  );
}
